import { Outlet, createRootRoute } from "@tanstack/react-router";
import { installFrontendErrorListeners } from "@actionary/frontend-substrate";

import { PortalErrorBoundary } from "@/components/portal-error-boundary";

// Side-effect: registers window error + unhandledrejection listeners
// on first import. Same substrate the admin SPA uses — every failure
// on any portal route reports through `/platform/frontend-errors`
// and the operator triage view sees admin + portal errors in one
// stream. Idempotent.
installFrontendErrorListeners();

/**
 * The portal root wraps every tenant surface. Attribution renders
 * per route — dashboards ship a `<PortalFooter />` inside their
 * `<PortalShell>`, standalone routes (form renderer, thanks page,
 * asset / page detail, partner login) carry their own inline copy —
 * so the root doesn't repeat the "Powered by ActionaryCRM" line at
 * the viewport bottom. The shared page background lives here so
 * every route paints against the same slate ground regardless of
 * theme. The PortalErrorBoundary composes the shared
 * FrontendErrorBoundary substrate — every SPA in the workspace
 * mounts one of these, admin included, so a render failure lands the
 * same "team notified" recovery UI regardless of surface.
 */
export const Route = createRootRoute({
  component: () => (
    <PortalErrorBoundary>
      <main className="min-h-screen bg-slate-50 dark:bg-slate-950">
        <Outlet />
      </main>
    </PortalErrorBoundary>
  ),
});
